
import { Component } from '@angular/core';

@Component({
  selector: 'ngde-privacy-policy',

  imports: [],
  template: `
    <section class="py-20 bg-gray-50 dark:bg-gray-900">
      <div class="container mx-auto px-4">
        <div class="max-w-4xl mx-auto">
          <h1 class="text-4xl font-bold mb-8">
            Privacy Policy / Data Protection Declaration
          </h1>

          <div class="prose dark:prose-invert max-w-none">
            <h2 class="text-2xl font-bold mb-4">General Information</h2>
            <p class="mb-6">
              As being responsible for this website, we take the protection of
              your personal data very seriously. We treat your personal data
              confidentiality in particular in accordance with the statutory
              data protection regulations. By using this website, various
              personal data is collected. Personal data is data that you can be
              personally identified with. This data protection declaration
              describes which data we collect and for what we use it. It also
              explains how and for what purpose this is done.
            </p>
            <p class="mb-6">
              We would like to point out that data transmission over the
              Internet (e.g. communication by e-mail) can have security gaps. A
              complete protection of data against access by third parties is not
              possible.
            </p>

            <h2 class="text-2xl font-bold mb-4">Responsible for the website</h2>
            <p class="mb-6">
              Symetics GmbH<br />
              c/o Factory<br />
              Lohmühlenstraße 65<br />
              12435 Berlin<br />
              Germany
            </p>

            <h2 class="text-2xl font-bold mb-4">
              Responsible for data protection
            </h2>
            <p class="mb-6">
              Symetics GmbH<br />
              c/o CIC<br />
              Lohmühlenstraße 65<br />
              12435 Berlin<br />
              Germany<br />
              Robin Böhm<br />
              E-Mail: robin.boehm&#64;angular.de
            </p>

            <h2 class="text-2xl font-bold mb-4">Visiting our Website</h2>
            <p class="mb-6">
              By visiting our website we process certain data of our visitors.
              What kind of data, on which legal basis, for what purpose and for
              how long we process, please read our subsequent data privacy
              policy.
            </p>

            <h2 class="text-2xl font-bold mb-4">Providing our Website</h2>
            <p class="mb-4">
              By loading our webpage, some data is being stored in a web server
              protocol file:
            </p>
            <ul class="list-disc pl-6 mb-6">
              <li>Date and time of the request for the load of the web page</li>
              <li>
                Size of the data package being transmitted within the connection
              </li>
              <li>
                Type and version of the used browser as well as your IP address
              </li>
            </ul>

            <h2 class="text-2xl font-bold mb-4">Github</h2>
            <p class="mb-6">
              Github is a cloud service provider and content delivery network.
              Here we host and operate our website. Legal basis for using GitHub
              on our website is the privacy shield framework. We may process
              your personal data until our legitimate interest ceases to exist.
            </p>
            <p class="mb-6">
              For more details of Githubs privacy and security processes, please
              visit
              <a
                href="https://help.github.com/articles/github-privacy-statement/"
                class="text-primary-500 hover:text-primary-600"
                target="_blank"
                rel="noopener noreferrer"
                >GitHub Privacy Statement</a
              >.
            </p>

            <h2 class="text-2xl font-bold mb-4">
              Data Sharing for Funding Programs
            </h2>
            <p class="mb-6">
              For the proper accounting of funding under the "Kongressfonds für nachhaltiges Tagen" 
              (Congress Fund for Sustainable Events) program, we may share the following personal data 
              with the Senatsverwaltung für Wirtschaft, Energie und Betriebe (Senate Administration 
              for Economics, Energy and Public Enterprises):
            </p>
            <ul class="list-disc pl-6 mb-6">
              <li>First and last names</li>
              <li>Institution/Organization</li>
              <li>Location/City</li>
              <li>Country</li>
            </ul>
            <p class="mb-6">
              This data sharing is necessary to comply with the funding guidelines and to ensure 
              proper accounting of the received funding. The legal basis for this processing is 
              our legitimate interest in complying with funding requirements.
            </p>

            <h2 class="text-2xl font-bold mb-4">
              Rights according to legal data protection regulations
            </h2>
            <p class="mb-4">
              You have the right to request information, correction, deletion or
              blocking of your personal data. As far as you should request
              deletion of your personal data stored by us, we will execute your
              request without undue delay, unless legal duties for documentation
              or storage apply. You can object to the usage of your personal
              data for advertising or market research purposes or revoke given
              opt-ins at any time.
            </p>
            <p class="mb-4">
              In case we process personal data of you, you are so called
              "affected" within the meaning of the General Data Protection
              Regulation (GDPR) and you have the following rights vis-à-vis the
              controller:
            </p>
            <ul class="list-disc pl-6 mb-6">
              <li>Right to information according to Art. 15 GDPR</li>
              <li>
                Right to correct any information that is inaccurate or
                incomplete according to Art. 16 GDPR
              </li>
              <li>Right to Deletion according to Art. 17 GDPR</li>
              <li>
                Right to limitation of processing according to Art. 18 GDPR
              </li>
              <li>Right to data transferability according to Art. 20 GDPR</li>
              <li>
                Right of contradiction/revocation of permission according to
                Art. 21 GDPR
              </li>
              <li>
                Right of complaint to the national supervisory authority
                according to Art. 13 para. 2 lit. d) GDPR
              </li>
            </ul>

            <h2 class="text-2xl font-bold mb-4">Children</h2>
            <p class="mb-6">
              Persons under 16 should not send us personal data without the
              consent of their parents or persons with parental power. We ask
              for no personal data from children and adolescents, nor do we
              collect such information nor pass it on to third parties.
            </p>

            <h2 class="text-2xl font-bold mb-4">Use Of Cookies</h2>
            <p class="mb-6">
              Cookies are small text files that are stored on your computer and
              saved by your browser. Cookies do not cause any damage to your
              computer and do not contain any viruses. Our cookies remain stored
              on your terminal for a certain period of time.
            </p>
            <p class="mb-6">
              In your browser settings, you can determine whether you want to be
              informed merely about the setting of a cookie, whether you want to
              grant or exclude permission either for individual cases or for
              cookies in general, or whether you want cookies to be
              automatically deleted when your browser is closed. Disabling
              cookies may limit the functionality of this website.
            </p>

            <h2 class="text-2xl font-bold mb-4">Newsletter</h2>
            <p class="mb-6">
              With the following information we inform you about the contents of
              our newsletter as well as the registration, dispatch and
              statistical evaluation procedures as well as your right of
              objection. By subscribing to our newsletter, you agree to the
              receipt and the procedures described.
            </p>
            <p class="mb-6">
              The legal basis for sending our newsletter is your consent via
              double opt-in according to Art. 6 para. 1 lit. a GDPR.
            </p>

            <h2 class="text-2xl font-bold mb-4">Link to third parties</h2>
            <p class="mb-6">
              You will find links to other websites on this website, directly or
              indirectly by means of links. The legal basis for such processing
              is our legitimate interest pursuant to Art. 6 para. 1 lit. f)
              GDPR. We may process your personal data until our legitimate
              interest ceases to exist.
            </p>
            <p class="mb-6">
              We hereby expressly distance ourselves from all contents of these
              sites to which links are established and do not adopt these
              contents as our own. We do not have any influence on changes of
              the linked content.
            </p>

            <h2 class="text-2xl font-bold mb-4">Use of YouTube</h2>
            <p class="mb-6">
              Our website uses the YouTube video platform operated by YouTube
              LLC, 901 Cherry Ave. San Bruno, CA 94066 USA. YouTube is a
              platform that enables playback of audio and video files. When you
              load a page on our website, the integrated YouTube player
              establishes a connection to YouTube in order to ensure the
              technical transmission of the video or audio file.
            </p>

            <h2 class="text-2xl font-bold mb-4">Google Maps</h2>
            <p class="mb-6">
              Our website uses the map service Google Maps via an API. The
              provider is Google Inc, 1600 Amphitheatre Parkway, Mountain View,
              CA 94043, USA. To use the functions of Google Maps it is necessary
              to save your IP address.
            </p>

            <h2 class="text-2xl font-bold mb-4">Google Analytics</h2>
            <p class="mb-6">
              This website uses functions of the web analytics service Google
              Analytics. Provider is Google Inc., 1600 Amphitheater Parkway,
              Mountain View, CA 94043, USA.
            </p>

            <h2 class="text-2xl font-bold mb-4">Twitter</h2>
            <p class="mb-6">
              This website uses functions of the web analytics service Twitter
              Universal Website Tag. Provider is Twitter, Inc., 1355 Market
              Street, Suite 900, San Francisco, CA 94103
            </p>

            <h2 class="text-2xl font-bold mb-4">Facebook</h2>
            <p class="mb-6">
              This website uses functions of the web analytics service Facebook
              Pixel. Provider is Facebook, Inc., 1 Hacker Way, Menlo Park,
              California 94025
            </p>

            <p class="text-sm text-gray-500 mt-8">Version: Jul 2019</p>
          </div>
        </div>
      </div>
    </section>
  `
})
export class PrivacyPolicyComponent {}
